export function shouldRemoveNavigationJourneyId(
  journey_id: string | null,
  default_trip_by_journey_id: string | null | undefined,
  inventory_ready: boolean
): boolean {
  return !!journey_id && !default_trip_by_journey_id && inventory_ready;
}
